export { StarRating } from './StarRating';
